import { useEffect, useState } from 'react';
import { getApiUrl } from '../config/config';

const defaults = { discord_url: '', telegram_url: '', twitter_url: '', support_email: 'support@bucx.io' };

export function useSiteSettings() {
  const [settings, setSettings] = useState(defaults);
  useEffect(() => {
    fetch(`${getApiUrl()}/site/settings`).then(response => response.ok ? response.json() : defaults).then(setSettings).catch(() => {});
  }, []);
  return settings;
}
